module.exports = __webpack_public_path__ + "static/media/ab1.954a8b87.png";